/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import Button from '../buttons/Button';

import styles from '../../../styles/filters/toggle.module.scss';

const propTypes = {
    onChange: PropTypes.func,
    // eslint-disable-next-line react/forbid-prop-types
    value: PropTypes.any,
    filter: PropTypes.shape({
        type: PropTypes.string,
        id: PropTypes.string,
        name: PropTypes.string,
        count: PropTypes.number,
    }),

    className: PropTypes.string,
};

const defaultProps = {
    onChange: null,
    value: null,
    filter: null,
    className: null,
};

const ToggleFilter = ({ onChange, value, filter, className }) => {
    const { label = null, multiple, value: filterValue = null, count = 0 } = filter || {};

    if (label === null) {
        return null;
    }

    const values = value || [];
    const toggled = multiple
        ? values !== null && (values || []).includes(filterValue)
        : (value === filterValue && filterValue !== null) ||
          (value !== null && filterValue === null);

    const onToggleChange = useCallback(
        (e, newValue) => {
            e.preventDefault();
            if (!multiple) {
                onChange(toggled ? null : newValue);
                return;
            }
            const valuesUpdate = [...values];
            if (!values.includes(newValue)) {
                valuesUpdate.push(newValue);
                onChange(valuesUpdate);
            } else {
                const filteredOptions = valuesUpdate.filter((op) => op !== newValue);
                onChange(filteredOptions);
            }
        },
        [onChange, filter, multiple, toggled],
    );

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <Button
                key={label}
                className={classNames([
                    styles.button,
                    styles[value],
                    {
                        [styles.toggled]: toggled,
                    },
                ])}
                onClick={(e) => onToggleChange(e, filterValue || true)}
            >
                {label}
                {multiple ? <sup className={styles.sup}>{count}</sup> : null}
            </Button>
        </div>
    );
};

ToggleFilter.propTypes = propTypes;
ToggleFilter.defaultProps = defaultProps;

export default ToggleFilter;
